/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pol_Scenario_B2Inputs */

const en_pol_scenario_b2 = /** @type {(inputs: Pol_Scenario_B2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private cloud space with your login`)
};

const id_pol_scenario_b2 = /** @type {(inputs: Pol_Scenario_B2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruang cloud pribadi dengan login kamu`)
};

/**
* | output |
* | --- |
* | "Private cloud space with your login" |
*
* @param {Pol_Scenario_B2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pol_scenario_b2 = /** @type {((inputs?: Pol_Scenario_B2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pol_Scenario_B2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pol_scenario_b2(inputs)
	return en_pol_scenario_b2(inputs)
});